import { render, staticRenderFns } from "./OwnerBuildingsView.vue?vue&type=template&id=139ce6e3&scoped=true"
import script from "./OwnerBuildingsView.vue?vue&type=script&lang=js"
export * from "./OwnerBuildingsView.vue?vue&type=script&lang=js"
import style0 from "./OwnerBuildingsView.vue?vue&type=style&index=0&id=139ce6e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139ce6e3",
  null
  
)

export default component.exports